import React, { VoidFunctionComponent } from 'react';
import { Grid, GridProps } from '../../grid/Grid/Grid';
import { GridItem } from '../../grid/GridItem/GridItem';
import { FilterPipelineHandle } from '../../hooks/useFilterPipeline/useFilterPipeline';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './FilterBar.module.css';

export type FilterBarProps = PropsWithoutChildren<GridProps> & {
  handle: FilterPipelineHandle;
};

export const FilterBar: VoidFunctionComponent<FilterBarProps> = React.memo(
  (props) => {
    const { handle, className, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <Grid
        {...remainingProps}
        className={classes(className, styles.container)}
      >
        {handle.renderFilters().map((filter) => {
          return (
            <GridItem
              key={filter.id}
              size={filter.size}
            >
              {filter.element}
            </GridItem>
          );
        })}
      </Grid>
    );
  }
);
